class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    console.log(this);
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}


class CurrencyForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    console.log(this);
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}


jQuery(document).ready(function(){
  var total_count = 0;
  var previous_total_count = 0;
  if(jQuery(".collection-toolbar__products-count").length > 0) {
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
  }

  if(jQuery(".product-gallery__carousel.init").length > 0) {
    jQuery(".product-gallery__carousel").removeClass("init");
  }

  jQuery(document).on("click", "div[data-block-type='variant-picker'] .block-swatch", function(){
    setTimeout(function(){
      const urlParams = new URLSearchParams(window.location.search);
      const variant_id = urlParams.get('variant');
      jQuery(".v-stack .price-list.price-list--product .custom-sale-price-price.h4.text-subdued").attr("data-variant-id", variant_id);
      jQuery(".v-stack .price-list .custom-sale-price-.h6.text-subdued").attr("data-variant-id", variant_id);
    }, 50);
  });

  setInterval(function(){
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
    if(previous_total_count != total_count) {
      previous_total_count = total_count;
      jQuery(".total_filtered_products").text(total_count);
    }
  }, 500);

  
  jQuery(document).on("click", ".facets-drawer .checkbox-control label", function(){
    // alert();
    console.log("First Visit: ", first_visit);
    var clicked_label = jQuery(this).text();

    if(!first_visit) {
      if(jQuery(this).prev("input").is(":checked")) {
        // alert("Checked");
        jQuery(this).prev("input").prop('checked', false);
        jQuery(this).prev("input").removeAttr('checked');
      } else {
        // alert("Not Checked");
        jQuery(this).prev("input").prop('checked', true);
        jQuery(this).prev("input").attr('checked', 'checked');
      }
    }

    first_visit = false;
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
    previous_total_count = total_count;
    jQuery(".total_filtered_products").text(total_count);
    // alert(clicked_label);
    setTimeout(function(){
      jQuery(".facets-sidebar .checkbox-control label[data-label='"+clicked_label+"']").trigger("click");
    }, 50);
  });

  jQuery(".thumbnail-swatch.design-swatch").on("click", function(){
    let value = jQuery(this).find(".sr-only").text();
    jQuery(".active_variant_value").text(value);
  });

  if(jQuery(".thumbnail-swatch.design-swatch").length > 0) {
    if(jQuery(".variant-picker__option-variant_picker :checked").length > 0) {
      let value = jQuery(".variant-picker__option-variant_picker :checked + .thumbnail-swatch").find(".sr-only").text();
      jQuery(".active_variant_value").text(value);
    }
    
  }

  // if(jQuery("product-gallery-navigation").length > 0) {
  //   url = new URL(window.location.href);

  //   if (!url.searchParams.has('variant')) {
  //     jQuery("product-gallery-navigation button.product-gallery__thumbnail:first-child").trigger("click");
  //   }
    
    
  // }

  customElements.define('currency-form', CurrencyForm);
  customElements.define('localization-form', LocalizationForm);
  // jQuery(document).on("click", ".facets-clear-all, .facets-drawer div[part=overlay]", function(){
  //   first_visit = true;
  // });
});